import { SuggestionPipelines } from 'types/suggestions/CoreSuggestions';

// Framer-motion presets for Kit expand/collapse
export const KIT_ANIMATIONS = {
  toggle: {
    initial: { opacity: 0, height: 0 },
    animate: { opacity: 1, height: 'auto' },
    exit: { opacity: 0, height: 0 },
    transition: { duration: 0.15 },
  },
};

export const SUGGESTIONS_PAGE_SIZE = 5;

// Open delay for Kit suggestion Preview tooltips
export const KIT_PREVIEW_OPEN_DELAY_MS = 80;

// Cap for Kit Preview width
export const KIT_PREVIEW_MAX_WIDTH_PX = 264;

// Floor so Preview stays readable in very narrow sidebars
export const KIT_PREVIEW_MIN_WIDTH_PX = 160;

// Pipelines shown in Load view (thread-linked load suggestions)
export const LOAD_VIEW_PIPELINES: SuggestionPipelines[] = [
  SuggestionPipelines.CarrierInfo,
  SuggestionPipelines.ApptConfirmation,
  SuggestionPipelines.CheckCall,
];

// Pipelines shown in Quote view (thread-linked quote suggestions)
export const QUOTE_VIEW_PIPELINES: SuggestionPipelines[] = [
  SuggestionPipelines.QuickQuote,
  SuggestionPipelines.LoadBuilding,
];

// Default order of pipeline sections in Quote view Kit
export const PIPELINE_DISPLAY_ORDER: SuggestionPipelines[] = [
  ...QUOTE_VIEW_PIPELINES,
  ...LOAD_VIEW_PIPELINES,
];
